import { useState } from "react";
import { useData, useDispatch } from "./DataContext.js";
import { getSimParam, timeToString } from "./utils.js";

import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ButtonGroup from "react-bootstrap/ButtonGroup";

import CardTitle from "./CardTitle.js";
import Dialog from "./Dialog.js";
import ButtonGrid from "./ButtonGrid.js";
import AmendmentList from "./AmendmentList.js";

export default function SimCard (props)
{
    const gData = useData();
    const gDispatch = useDispatch();
    //if (gData.sim[props.simID] === undefined) return (<></>);

    const sim = gData.sim[props.simID];

    const creationTime = timeToString(sim.creationTime);
    const simTitle = sim.title;

    const studentNb = Object
	.entries(gData.student)
	.filter(([id, student]) => student.simID === props.simID)
	.length;

    const groupNb = Object
	.entries(gData.group)
	.filter(([id, group]) => group.simID === props.simID && group.selected)
	.length;

    let simStatus = "";
    if (sim.sessionNum === 0) simStatus = "En préparation";
    else {
	simStatus = "Session n°" + sim.sessionNum;
	const sessionStep = getSimParam(gData, "sessionStep", props.simID);
	if (sessionStep === "write") simStatus += " / Phase de négociation";
	else if (sessionStep === "present") simStatus += " / Phase de délibération";
	else if (sessionStep === "end") simStatus += " / Terminée";
    }
    
    const institutionTitle = sim.institutionID === null ? "En cours de création..." : gData.institution[sim.institutionID].title;;
    const scenarioTitle = sim.scenarioID === null ? "En cours de création..." : gData.scenario[sim.scenarioID].title;
    const durationTitle = sim.durationID === null ? "En cours de création..." : gData.duration[sim.durationID].title;

    // OPEN SIM
    function openSim () { gDispatch({ type: "openSim", simID: props.simID }); }

    // ARCHIVE SIM
    function archiveSim () { gDispatch({ type: "upload", table: "sim", id: props.simID, data: { state: "archived" } }); }

    const [archiveConfirm, setArchiveConfirm] = useState(false);
    function showArchiveConfirm () { setArchiveConfirm(true); }
    function hideArchiveConfirm () { setArchiveConfirm(false); }

    const archiveConfirmDialog = (
	<Dialog show={archiveConfirm} hide={hideArchiveConfirm} title="Archiver une SIM" confirm={archiveSim}>
	    <p>Cette SIM sera toujours disponible dans la liste de vos SIM archivées et pourra, si besoin, être désarchivée pour une future utilisation.</p>
	</Dialog>
    );

    // UNARCHIVE SIM
    function unarchiveSim () { gDispatch({ type: "upload", table: "sim", id: props.simID, data: { state: "ongoing" } }); }

    const [unarchiveConfirm, setUnarchiveConfirm] = useState(false);
    function showUnarchiveConfirm () { setUnarchiveConfirm(true); }
    function hideUnarchiveConfirm () { setUnarchiveConfirm(false); }

    const unarchiveConfirmDialog = (
	<Dialog show={unarchiveConfirm} hide={hideUnarchiveConfirm} title="Désarchiver une SIM" confirm={unarchiveSim}>
	    <p>Cette SIM sera a nouveau disponible dans la liste de vos SIM en cours.</p>
	</Dialog>
    );

    // DELETE SIM
    function deleteSim () { gDispatch({ type: "deleteSim", simID: props.simID }); }

    const [deleteConfirm, setDeleteConfirm] = useState(false);
    function showDeleteConfirm () { setDeleteConfirm(true); }
    function hideDeleteConfirm () { setDeleteConfirm(false); }

    const deleteConfirmDialog = (
	<Dialog show={deleteConfirm} hide={hideDeleteConfirm} confirm={deleteSim} title="Supprimer une SIM">
	    <p>Attention : suppression définitive.</p>
	    <p>Les données de cette SIM ne pourront pas être récupérées.</p>
	</Dialog>
    );

    return (
	<>
	    <Card className="shadow-sm" style={{ width: "800px" }}>
		<Card.Header>
		    <CardTitle title={simTitle} subtitle="Simulation"/>
		</Card.Header>
		<Card.Body className="d-flex flex-column gap-3">
		    <Row>
			<Col xl={4}>
			    <div className="small text-muted text-uppercase">Institution</div>
			    <div>{institutionTitle}</div>
			</Col>
			<Col xl={4}>
			    <div className="small text-muted text-uppercase">Scénario</div>
			    <div>{scenarioTitle}</div>
			</Col>
			<Col xl={4}>
			    <div className="small text-muted text-uppercase">Format</div>
			    <div>{durationTitle}</div>
			</Col>
		    </Row>
		    <Row>
			<Col xl={4}>
			    <div className="small text-muted text-uppercase">Date de création</div>
			    <div>{creationTime}</div>
			</Col>
			<Col xl={4}>
			    <div className="small text-muted text-uppercase">Effectifs</div>
			    <div>{groupNb} groupe{groupNb > 1 ? "s" : ""} / {studentNb} élève{studentNb > 1 ? "s" : ""}</div>
			</Col>
			<Col xl={4}>
			    <div className="small text-muted text-uppercase">Statut</div>
			    <div>{simStatus}</div>
			</Col>
		    </Row>
		    {sim.sessionNum > 0 && (
			<div className="d-flex align-items-center gap-4">
			    <div className="small text-muted text-uppercase">Amendements</div>
			    <ButtonGroup>
				<AmendmentList.Buttons simID={props.simID} stateList={["waiting", "submitted", "accepted", "rejected"]} size="sm" disabled/>
			    </ButtonGroup>
			</div>
		    )}
		</Card.Body>
		<Card.Footer>
		    <ButtonGrid>
			<ButtonGrid.Left>
			    {sim.state === "ongoing" && (<Button type="button" variant="outline-secondary" size="md" onClick={showArchiveConfirm}>Archiver</Button>)}
			    {sim.state === "archived" && (<Button type="button" variant="outline-secondary" size="md" onClick={showUnarchiveConfirm}>Désarchiver</Button>)}
			    <Button type="button" variant="outline-secondary" size="md" onClick={showDeleteConfirm}>Supprimer</Button>
			</ButtonGrid.Left>
			<ButtonGrid.Right>
			    {sim.state === "ongoing" && (<Button type="button" variant="primary" size="md" onClick={openSim}>Ouvrir</Button>)}
			</ButtonGrid.Right>
		    </ButtonGrid>
		</Card.Footer>
	    </Card>
	    {deleteConfirmDialog}
	    {archiveConfirmDialog}
	    {unarchiveConfirmDialog}
	</>
    );
}
